<template>
  <request-profile
    @download-contract="downloadProfileContract"
    :is-individual="isIndividual"
    :is-identification-required="isIdentificationRequired"
    :on-validate="validateForm"
    :fields="fieldsWithScansObj"
    :on-create="createRequest"
    :onUpload="uploadScan"
    :regions="regions"
    :total="total"
    :productId="firstProductId"
    :productData="productData"
  />
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import {
  uploadContractFile,
  uploadOgrnFile,
  uploadPassportScans,
  downloadProfileContract,
} from '../../../services/api/file';
import { validateDefault } from './validate';
import RequestProfile from './RequestProfile.vue';

export default {
  name: 'request-profile-container',
  components: {
    RequestProfile,
  },
  methods: {
    ...mapActions('fileUploader', [
      'uploadProfileConsent',
      'uploadProfileOgrn',
      'uploadRequestPassportOgrn',
      'uploadAttorney',
    ]),
    ...mapActions('request', ['createRequest', 'resetState']),
    ...mapActions(['error']),

    downloadProfileContract({ type, values }) {
      return downloadProfileContract({
        type,
        values: {
          ...values,
          productId: this.firstProductId,
        },
      });
    },

    validateForm(values, hasPhone, isAgreementReceiptionRequired) {
      const fields = [...this.fieldsWithScans];
      if (hasPhone) {
        fields.push({ name: 'phone', required: true });
      }
      return validateDefault(values, fields, isAgreementReceiptionRequired);
    },

    uploadScan(field, files) {
      switch (field) {
        case 'contractScan':
          return this.uploadProfileConsent(files);
        case 'ogrnScan':
          return this.uploadRequestPassportOgrn(files);
        case 'passportScan':
          return this.uploadRequestPassportOgrn(files);
        case 'attorneyScan':
          return this.uploadAttorney(files);
        default:
          throw new Error(field + ' - invalid field');
      }
    },
  },
  created() {
    switch (true) {
      case !this.selectedProducts.length:
        this.$router.push({ name: 'requestProducts' });
        break;
      case this.isEgrip:
        this.$router.push({ name: 'requestEgrip' });
        break;
      case this.isEgrul:
        this.$router.push({ name: 'requestEgrul' });
        break;
      case this.isBalance:
        this.$router.push({ name: 'requestBalance' });
        break;
    }
  },
  computed: {
    ...mapGetters('request', [
      'selectedProducts',
      'productsObj',
      'fields',
      'total',
      'isIndividual',
      'isIdentificationRequired',
    ]),
    ...mapGetters('regions', ['regions']),

    firstProductId() {
      return this.selectedProducts[0];
    },
    productData() {
      return this.productsObj[this.firstProductId];
    },

    isCreditReportOrg() {
      return this.selectedProducts.some((productId) => {
        return (
          this.productsObj[productId].name.toLowerCase() ===
          'кредитный отчёт предприятия'
        );
      });
    },

    fieldsWithScans() {
      switch (true) {
        case !this.isIndividual && this.isIdentificationRequired:
          return this.fields.concat([
            { name: 'contractScan', required: true },
            { name: 'ogrnScan', required: true },
            { name: 'attorneyScan', required: false },
          ]);
        case this.isIndividual && this.isIdentificationRequired:
          return this.fields.concat([
            { name: 'contractScan', required: true },
            { name: 'passportScan', required: true },
          ]);
        default:
          return this.fields;
      }
    },

    fieldsWithScansObj() {
      return this.fieldsWithScans.reduce((newFields, field) => {
        newFields[field.name] = field;
        return newFields;
      }, {});
    },
  },
};
</script>



// WEBPACK FOOTER //
// RequestProfileContainer.vue?01c810b6